import instance from "./index";

export const getAllActiveSilos = async () => {
  return await instance.get("/silos");
};

export const createSilos = async (data) => {
  return instance.post("/silos", data);
};
